module.exports = __webpack_public_path__ + "img/goal.7d05f818.png";